import {isValid} from 'date-fns'
// import { isEmpty } from 'validator';
export function date(fieldName){
    let result = true;

    return (value = '') => {
      result = isValid(new Date(value))

        
        
    
        return result ? undefined : `${fieldName} must be a valid date`;
      };
}